import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const paymentsRoutesDictionary = moduleRouteDictionaryFactory(
  'payments',
  'payments',
  {
    list: 'list',
  },
);
